import { useCallback, useEffect, useState } from "react";
import {
  getAdminRewardVouchers,
  updateAdminRewardVoucherStatus,
} from "../../../api/adminPromoCodes";

const useAdminPromoCodes = ({ showFeedback }) => {
  const [rewardVouchers, setRewardVouchers] = useState([]);
  const [rewardVouchersLoading, setRewardVouchersLoading] = useState(false);
  const [rewardVouchersError, setRewardVouchersError] = useState("");
  const [rewardVoucherActionId, setRewardVoucherActionId] = useState(null);

  const loadRewardVouchers = useCallback(async () => {
    setRewardVouchersLoading(true);
    setRewardVouchersError("");
    try {
      const payload = await getAdminRewardVouchers();
      setRewardVouchers(Array.isArray(payload) ? payload : []);
    } catch (error) {
      setRewardVouchers([]);
      setRewardVouchersError(error?.message || "Failed to load reward vouchers.");
    } finally {
      setRewardVouchersLoading(false);
    }
  }, []);

  useEffect(() => {
    loadRewardVouchers();
  }, [loadRewardVouchers]);

  const updateRewardVoucherStatus = useCallback(
    async (voucherId, isActive) => {
      if (!voucherId) return;
      setRewardVoucherActionId(voucherId);
      try {
        const response = await updateAdminRewardVoucherStatus(voucherId, { isActive });
        setRewardVouchers((prev) =>
          prev.map((voucher) => (voucher.id === voucherId ? response : voucher))
        );
        showFeedback(isActive ? "Voucher reactivated." : "Voucher cancelled.", "success");
      } catch (error) {
        showFeedback(error?.message || "Unable to update voucher status.", "warning");
      } finally {
        setRewardVoucherActionId(null);
      }
    },
    [showFeedback]
  );

  return {
    rewardVouchers,
    rewardVouchersLoading,
    rewardVouchersError,
    rewardVoucherActionId,
    refreshRewardVouchers: loadRewardVouchers,
    updateRewardVoucherStatus,
  };
};

export default useAdminPromoCodes;
